import { NEUTRAL_700 } from 'visitor-ui-component-library/constants/WidgetColors';
const defaultQuickReplyTheme = {
  width: 'auto',
  minHeight: 36,
  borderColor: NEUTRAL_700,
  whitespace: 'normal',
  lineHeight: '1rem',
  color: NEUTRAL_700
};
const QuickReplyTheme = themeProps => Object.assign({}, defaultQuickReplyTheme, themeProps);
export default QuickReplyTheme;